<ng-container *transloco="let t">
  @if (patients) {
    @if (patients.length > 0) {
      @if ((isGamEnabled$ | async) && gamLinkedPatients.length > 0) {
        <ng-container
          [ngTemplateOutlet]="sectionTitle"
          [ngTemplateOutletContext]="{ title: t('Patients existants dans votre établissement') }" />
        @for (patient of gamLinkedPatients; track patient.id) {
          <ng-container [ngTemplateOutlet]="patientCard" [ngTemplateOutletContext]="{ patient: patient }" />
        }
      }
      @if (pixacarePatients.length > 0) {
        <ng-container
          [ngTemplateOutlet]="sectionTitle"
          [ngTemplateOutletContext]="{ title: t('Patients existants dans Pixacare') }" />
        @for (patient of pixacarePatients; track patient.id) {
          <ng-container [ngTemplateOutlet]="patientCard" [ngTemplateOutletContext]="{ patient: patient }" />
        }
      }
    } @else {
      <pxc-empty-state data-testid="no-identified-patient" [title]="t('Aucun patient n\'a été identifié.')" />
    }
  } @else {
    <pxc-loader class="my-auto" data-testid="loading" size="tiny" />
  }

  <ng-template #sectionTitle let-title="title">
    <p
      class="sticky top-0 z-10 border-b border-border-normal bg-background-primary p-2 text-sm font-medium text-text-tertiary lg:bg-background-primary-alt">
      {{ title }}
    </p>
  </ng-template>

  <ng-template #patientCard let-patient="patient">
    <button
      class="flex w-full gap-3 p-3 hover:bg-background-secondary"
      type="button"
      [attr.data-testid]="'select-patient-' + patient.id"
      (click)="onPatientClick(patient)">
      <pxc-patient-avatar size="small" [patient]="patient" />
      <pxc-patient-data size="small" [patient]="patient">
        <pxc-patient-link-quick-action *showIfClientIsGamEnabled="patient" />
      </pxc-patient-data>
    </button>
  </ng-template>
</ng-container>
